<template>
  <div class="relative">
    <button
        @click.stop="toggleChat"
        type="button"
        class="hover:text-primary-500 focus:outline-none focus:ring ring-primary-200 dark:ring-gray-600 rounded h-10 w-10"
    >
      <Icon type="bell" />

      <span
          v-if="nodeChatUnreadMessages"
          class="absolute border-[3px] border-white dark:border-gray-800 top-[3px] right-[4px] inline-block bg-red-500 rounded-full w-4 h-4"
      />
    </button>
  </div>
  <teleport to="#nodeChat">
    <transition>
      <div v-if="nodeChatShown" class="fixed flex inset-0">
        <div
            @click="toggleChat"
            class="absolute inset-0 bg-gray-600 dark:bg-gray-900 opacity-75"
            dusk="notifications-backdrop"
        />
        <node-chat-main :messages="nodeChatMessages" :message-totals="nodeChatMessageTotals" />
      </div>
    </transition>
  </teleport>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import NodeChatMain from './NodeChatMain'
const { mapMutations, mapActions, mapGetters } = createNamespacedHelpers('nova')

export default {
  components:{
    'node-chat-main': NodeChatMain,
  },
  name: "NodeChat",
  data: () => ({

  }),
  created() {
    //this.nodeChatInit()
  },
  // mounted() {
  //   this.mountedChatActione()
  // },
  watch: {
    chatShown(newValue){
      if(newValue === true){
        document.body.classList.add('overflow-y-hidden')
        return
      }

      document.body.classList.remove('overflow-y-hidden')
    },
    nodeChatShown() {
      this.nodeChatInit()
    }
  },

  mounted() {
    //this.nodeChatInit()
    //Nova.$on('refresh-notifications', () => this.fetchNotifications())
  },

  beforeUnmount() {
    document.body.classList.remove('overflow-y-hidden')
  },

  methods: {
    ...mapMutations(['toggleChat']),
    ...mapActions([
      'nodeChatInit',
      ]),
  },
  computed: {
    ...mapGetters([
        'nodeChatShown',
        'nodeChatMessages',
        'nodeChatUnreadMessages',
        'token',
        'authenticationClient',
        'nodeChatMessageTotals',
    ])
  }
}
</script>

<style scoped>

</style>
